import styled from 'styled-components/macro';

const Heading = styled.h1`
  font-size: 2rem;
  color: red;
`;

export default Heading;
